import React from 'react';

const FAQ = () => {
  return (
    <section id="faqs" className="faqs section py-5 light-background">
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-3">
            <div className="section-title aos-init aos-animate" data-aos="fade-up">
              <p><span>Frequently Asked</span> <span className="description-title">Questions</span></p>
            </div>
          </div>
          
          <div className="col-lg-9">
            <div className="accordion" id="faqsAcc">
              <div className="accordion-item mb-3 border rounded overflow-hidden">
                <h2 className="accordion-header">
                  <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs0" aria-expanded="false" aria-controls="faqs0">
                    When was Mewar University Established?
                  </button>
                </h2>
                <div id="faqs0" className="accordion-collapse collapse" data-bs-parent="#faqsAcc">
                  <div className="accordion-body fs-14">
                    <p>Mewar University was established in 2009 via The Mewar University, Chittorgarh Act, 2009 (Act No. 4 of 2009) passed by the Rajasthan Legislative Assembly.</p>
                  </div>
                </div>
              </div>
              
              <div className="accordion-item mb-3 border rounded overflow-hidden">
                <h2 className="accordion-header">
                  <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs1" aria-expanded="false" aria-controls="faqs1">
                    What is the B Tech for working professionals course?
                  </button>
                </h2>
                <div id="faqs1" className="accordion-collapse collapse" data-bs-parent="#faqsAcc">
                  <div className="accordion-body fs-14">
                    <p>B-Tech for Working Professionals courses are specially designed programs that allow employed individuals to upgrade their technical skills without leaving their jobs with online lecture in flexible shift timing.</p>
                  </div>
                </div>
              </div>
              
              <div className="accordion-item mb-3 border rounded overflow-hidden">
                <h2 className="accordion-header">
                  <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs2" aria-expanded="false" aria-controls="faqs2">
                    What is the specialization offered by Mewar University B.Tech Lateral Entry?
                  </button>
                </h2>
                <div id="faqs2" className="accordion-collapse collapse" data-bs-parent="#faqsAcc">
                  <div className="accordion-body fs-14">
                    <p>Mewar University, Chittorgarh, offers B.Tech Lateral Entry in the specializations of Computer Science, Mechanical, Civil, Electronics, chemical, Electrical and mining engineering.</p>
                  </div>
                </div>
              </div>
              
              <div className="accordion-item mb-3 border rounded overflow-hidden">
                <h2 className="accordion-header">
                  <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs3" aria-expanded="false" aria-controls="faqs3">
                    What is the fee for B.Tech Lateral Entry at Mewar University?
                  </button>
                </h2>
                <div id="faqs3" className="accordion-collapse collapse" data-bs-parent="#faqsAcc">
                  <div className="accordion-body fs-14">
                    <p>Mewar University's B.Tech. fees for the 2025-2026 academic year are ₹ 2,28,000 for a 3-year lateral entry program.</p>
                  </div>
                </div>
              </div>
              
              <div className="accordion-item mb-3 border rounded overflow-hidden">
                <h2 className="accordion-header">
                  <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs4" aria-expanded="false" aria-controls="faqs4">
                    Is Mewar University's offer valid B.Tech Lateral Entry program?
                  </button>
                </h2>
                <div id="faqs4" className="accordion-collapse collapse" data-bs-parent="#faqsAcc">
                  <div className="accordion-body fs-14">
                    <p>Yes, Mewar University is listed among colleges that offer a B.Tech Lateral Entry program.</p>
                  </div>
                </div>
              </div>
              
              <div className="accordion-item mb-3 border rounded overflow-hidden">
                <h2 className="accordion-header">
                  <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs5" aria-expanded="false" aria-controls="faqs5">
                    Who can enroll for the B.Tech Lateral Entry program at Mewar University?
                  </button>
                </h2>
                <div id="faqs5" className="accordion-collapse collapse" data-bs-parent="#faqsAcc">
                  <div className="accordion-body fs-14">
                    <p>To enroll in the B.Tech Lateral Entry program at Mewar University, candidates must typically have completed a relevant diploma in engineering or an equivalent qualification, such as a B.Sc. degree in a relevant field, to be considered eligible.</p>
                  </div>
                </div>
              </div>
              
              <div className="accordion-item mb-3 border rounded overflow-hidden">
                <h2 className="accordion-header">
                  <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs6" aria-expanded="false" aria-controls="faqs6">
                    Will I be eligible for government jobs after completing B.Tech Lateral Entry from Mewar University?
                  </button>
                </h2>
                <div id="faqs6" className="accordion-collapse collapse" data-bs-parent="#faqsAcc">
                  <div className="accordion-body fs-14">
                    <p>Yes, completing a B.Tech Lateral Entry degree from Mewar University will make you eligible for many government jobs, as the degree provides the fundamental qualifications needed for these roles, such as those in Public Sector Undertakings (PSUs), government engineering services, and defence services.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
